export default [
    {
        id: 1,
        name: "Pierre-and-Marie-Curie University",
        major: "Artificial Intelligence and Decision Making",
        degree: "Master",
        dated: "2014 - 2016",
        cgpa: "9.12"
    },
];
